import * as _ from 'lodash';
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { combineStyles, fonts, mixins } from '@blend/consumer-components';

import * as deploymentConfig from 'login-utils/deploymentConfig';

const loginBackgroundColor = deploymentConfig.getOrganizationColors().loginBackground;
const dynamicColor = mixins.dynamicColor(loginBackgroundColor);

const styles = StyleSheet.create({
  transparentButton: combineStyles(
    mixins.padding(10, 15),
    mixins.border(1, 'solid', dynamicColor),
    mixins.borderRadius(4),
    fonts.Roboto,
    {
      backgroundColor: mixins.rgba(0, 0, 0, 0),
      color: dynamicColor,
      cursor: 'pointer',
      display: 'block',
      fontSize: 14,
      fontWeight: fonts.weight.medium,
      height: 34,
      lineHeight: 0,
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
  ),
});

interface TransparentButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  buttonId?: string;
}

/* istanbul ignore next: (UI-5482) */
const TransparentButton = ({ text, buttonId, type = 'submit', onClick, ...htmlProps }: TransparentButtonProps) => {
  const handleOnClick = e => _.isFunction(onClick) && onClick(e);

  return (
    <button
      {...htmlProps}
      className={css(styles.transparentButton)}
      type={type}
      onClick={handleOnClick}
      id={buttonId}
      // when onClick is not passed to TransparentButton, TransparentButton is wrapped in a clickable element
      // already. Therefore, if no onClick passed to TransparentButton, we set tabIndex to -1 in order to avoid
      // the button being highlighted twice while navigating using TAB key
      tabIndex={_.isFunction(onClick) ? 0 : -1}
    >
      {text}
    </button>
  );
};

export default TransparentButton;
